<template>
    <div class="search_nodata">
        <div class="appear" v-if="showSearchNodata">
            <div class="img_wrap2">
                <img src="../../assets/images/parent-course/search-nodata.png" alt="">
            </div>
            <p class="desc_text">没有找到“{{searchContent}}”相关的内容</p>
        </div>
        
    </div>
</template>

<script>
export default {
  name: 'search-nodata',
  components: {},
  props: {
    showSearchNodata: {
        type: Boolean,
        default:false
    },
    searchContent:{
        type: String,
        default:'剑豪'
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {
    
},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang='scss'>
.search_nodata {
    text-align: center;
    .appear {
        display: flex;
        flex-direction: column;
        align-items: center;
        .img_wrap2 {
            width: 140px;
            min-height: 120px;
            img {
                width: 100%;
            }
        }
        .desc_text {
            margin-top: 11px;
            flex-wrap: wrap;
            // border: 1px solid red;
            width: 100%;
            color: #949C9D;
            font-size: 14px;
            flex-wrap: wrap;
            // text-overflow: ellipsis;
            // white-space: wrap;
            // overflow: hidden;
        }
    }
    
}
</style>

